// Shared auth-screen shell that mirrors the LoginPage look:
// illustrated background (mobile png + desktop jpg), floating logo + tagline,
// and a frosted white card. iOS safe-area aware (100dvh + env(safe-area-inset-*)).
// NOTE: mobile background is intentionally unchanged; only desktop bg may be swapped later.

import { useImmersiveStatusBar } from '../lib/useImmersiveStatusBar';

export const authInputClass =
  'w-full h-12 rounded-2xl bg-white border border-slate-200 text-base text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent transition-shadow';

export default function AuthLayout({ children, maxWidth = 'max-w-[340px] md:max-w-md', testId = 'auth-layout' }) {
  useImmersiveStatusBar();
  return (
    <div
      className="relative min-h-[100dvh] w-full flex flex-col md:justify-center md:items-center overflow-y-auto overscroll-none"
      data-testid={testId}
    >
      {/* Mobile background: full illustration, pinned to top (unchanged) */}
      <div
        className="fixed inset-0 -z-10 md:hidden"
        style={{
          backgroundImage: "url('/login-bg-mobile.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
          backgroundColor: '#DCEAF9',
        }}
      />
      {/* Desktop background: generated widescreen scene */}
      <div
        className="fixed inset-0 -z-10 bg-cover bg-center bg-no-repeat hidden md:block"
        style={{ backgroundImage: "url('/login-bg-desktop.webp')" }}
      />

      {/* Logo + tagline over the illustration */}
      <div className="flex flex-col items-center px-6 pt-[calc(env(safe-area-inset-top)+2rem)] md:pt-0 md:mb-7">
        <div className="w-24 h-24 md:w-32 md:h-32">
          <img
            src="/logo-new.png"
            alt="GuestCheckout"
            className="w-full h-full object-contain"
          />
        </div>
      </div>

      {/* Spacer pushes the sheet toward the bottom on mobile, revealing the village */}
      <div className="flex-1 md:hidden" />

      {/* Frosted card */}
      <div className="w-full flex justify-center px-4 pb-[calc(env(safe-area-inset-bottom)+1.25rem)] md:px-4 md:pb-3">
        <div
          className={`w-full ${maxWidth} bg-white/80 md:bg-white backdrop-blur-lg md:backdrop-blur-none rounded-[1.75rem] md:rounded-[2rem] shadow-[0_12px_44px_rgba(15,23,42,0.20)] md:shadow-2xl px-5 md:px-8 pt-5 md:pt-7 pb-5 md:pb-7`}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
